if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.sliderInstance = false;
        if (!this.enableSlider) return;
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        const items = parseFloat(this.dataset.items || '1');
        const itemsMobile = parseFloat(this.dataset.itemsMobile || '1');
        this.sliderOptions = { 
          spaceBetween: 16,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            clickable: true,
            dynamicBullets: true
          },
          breakpoints: {
            1024: {
              slidesPerView: items,
            },
            768: {
              slidesPerView: 3,
            },
            360:{
              slidesPerView: itemsMobile,
            }
          },
          loop: false,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }
      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;
        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }
      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;
        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }
      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
// Events JS Start 
document.addEventListener("DOMContentLoaded", function () {
  const productLists = document.querySelectorAll(".featured-collection__items");
  if (!productLists.length || typeof GA4Events === "undefined" || typeof GA4Events.viewItemList !== "function" || typeof GA4Events.selectItem !== "function") return;
  productLists.forEach((productList) => {
    productList.addEventListener("click", function (e) {
      if (e.target.closest(".product-card")?.hasAttribute("data-ga-clicked")) return;
      const productCard = e.target.closest(".product-card");
      if (!productCard || !productList.contains(productCard)) return;
      productCard.setAttribute("data-ga-clicked", "true");
      setTimeout(() => { productCard.removeAttribute("data-ga-clicked"); }, 500);
      const productLink = productCard.querySelector("a.reversed-link");
      const priceEl = productCard.querySelector(".f-price-item--regular.sale_prices_new");
      const originalPriceEl = productCard.querySelector(".f-price-item--regular.sale_prices s");
      const productName = productLink?.textContent.trim() || "NA";
      const productId = productCard.querySelector("input[name='product-id']")?.value || "NA";
      const variantId = productCard.querySelector("input[name='id']")?.value || "NA";
      const price = parseInt((priceEl?.textContent || "0").replace(/[^\d]/g, '')) || 0;
      const originalPrice = parseInt((originalPriceEl?.textContent || "0").replace(/[^\d]/g, '')) || price;
      const discount = originalPrice - price;
      const index = [...productList.querySelectorAll(".product-card")].indexOf(productCard) + 1;
      const item_list_id = productList.getAttribute("data-list-id") || "collection_home";
      const item_list_name = productList.getAttribute("data-list-name") || "Featured Collection";
      const item_brand = "Re'equil";
      const item_category = "Skincare";
      const item_category2 = "Radiance";
      const itemData = {
        item_id: productId,
        item_name: productName,
        coupon: "",
        discount: discount,
        index: index,
        item_brand,
        item_category,
        item_category2,
        item_variant: variantId,
        price,
        quantity: 1
      };
      GA4Events.selectItem({
        item_list_id,
        item_list_name,
        items: [itemData]
      });
    });
  });

  // Swiper event tracking
  if (typeof Swiper !== "undefined") {
    const sliders = document.querySelectorAll("featured-collection.swiper");
    sliders.forEach((slider) => {
      const swiperInstance = slider.swiper;
      
      if (swiperInstance && !swiperInstance._swipeBound) {
        swiperInstance._swipeBound = true;
        swiperInstance.on("slideChange", function () {
          const currentIndex = swiperInstance.activeIndex;
          const prevIndex = swiperInstance.previousIndex;
          let swipeDirection = "";
          if (prevIndex !== undefined && prevIndex !== null) {
            swipeDirection = currentIndex > prevIndex ? "right" : "left";
          }
          // const pageSection = slider.getAttribute("data-section-id") || "featured_collection";
          const pageSection = "Featured Collection" || "featured_collection";
          console.log('pageSection:',pageSection);
          const regimeStep = currentIndex + 1;
          Moengage.track_event("product_card_swipe", {
            "page_section": pageSection,
            "swipe_direction": swipeDirection,
            "card_position": currentIndex,
            "regime_step": regimeStep,
          });
          console.log('product_card_swipe:', {
            page_section: pageSection,
            swipe_direction: swipeDirection,
            card_position: currentIndex,
            regime_step: regimeStep,
          });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "product_card_swipe",
            page_section: pageSection,
            swipe_direction: swipeDirection,
            card_position: currentIndex,
            regime_step: regimeStep,
          });
        });
      }
    });
  }
});

